import './MixAnimateIcon.css';

import { cn } from '##/utils/bem';

export const cnMixAnimateIcon = cn('MixAnimateIcon');
